import React from 'react';
import {
  string, shape, arrayOf, bool, array,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import paymentMethodsMap from '../../../../../shared/config/paymentMethodsMap';
import PaymentInfoFields, { StaticField } from '../../../staticFields/PaymentInfoFields';
import PaymentInfoTag from '../PaymentInfoTag';
import ActiveStatement from './components/ActiveStatement';

const PaymentInfo = ({
  paymentResultList, isOrderSummary, installments = [], ...rest
}) => {
  if (paymentResultList.length === 0) {
    return null;
  }

  return (
    <div className="payment-info">
      <div className="payment-info-title" >
        <Locale id="checkout.lib.components.paymentResult.detail.paymentInfo.title" />
      </div>
      {!!paymentResultList.length && !!installments.length
        && <PaymentInfoTag paymentMethodType={paymentResultList[0].paymentAccount.tenderType} />
      }
      <div className="payment-info-content" >
        {
          paymentResultList.map((paymentResult, idx) => {
            const {
              paymentAccount: { tenderType, maskedNumber, type },
              billingContact: { firstName, lastName } = {}, amount, currencyCode,
            } = paymentResult;
            const paymentInfoData = {
              tenderType, maskedNumber, type, amount, currencyCode,
            };
            if (!paymentMethodsMap[tenderType]) {
              return null;
            }
            return (<React.Fragment key={tenderType}>
              <div className="payment-info__field">
                <PaymentInfoFields {...paymentInfoData} />
                {
                  isOrderSummary ? <React.Fragment>
                    {
                      firstName && lastName
                    && <StaticField
                      label="checkout.lib.components.paymentResult.summary.billTo">
                      {`${firstName} ${lastName}`}
                    </StaticField>
                    }
                  </React.Fragment> : amount > 0 && <ActiveStatement data-testid="payment-Info-active-statement" {...rest} paymentResult={paymentResult} />}
              </div>
              {idx < paymentResultList.length - 1 && <div className="hr-line" />}
            </React.Fragment>);
          })
        }
      </div>
    </div>
  );
};

PaymentInfo.propTypes = {
  isOrderSummary: bool,
  paymentResultList: arrayOf(shape({
    paymentAccount: shape({
      tenderType: string,
    }),
  })),
  installments: array,
};

PaymentInfo.defaultProps = {
  paymentResultList: [],
  isOrderSummary: false,
  installments: [],
};

export default PaymentInfo;
